'use client';

import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/24/solid';
import { Breadcrumbs } from '@mantine/core';
import Link from 'next/link';
import React from 'react';

import styles from './styles.module.scss';
import { BreadcrumbProps } from './types';

const Breadcrumb = ({
  items,
  isMobile,
  mobileOption,
  mobileOptionSrc,
}: BreadcrumbProps) => {
  let lastElement = items[items.length - 1];
  let lastIndex = items.lastIndexOf(lastElement);

  const renderItems = () => {
    return isMobile
      ? mobileOption && (
          <div className={styles.backToHomepage}>
            <ChevronLeftIcon className={styles.separator} />
            <Link
              href={mobileOptionSrc ? `${mobileOptionSrc}` : '/'}
              className={styles.breadcrumb}
            >
              Wróć do {mobileOption}
            </Link>
          </div>
        )
      : items.map((item, index) =>
          index === lastIndex ? (
            <p key={index} className={styles.lastBreadcrumb}>
              {item.title}
            </p>
          ) : (
            <Link href={item.href} key={index} className={styles.breadcrumb}>
              {item.title}
            </Link>
          ),
        );
  };

  return (
    <Breadcrumbs
      separator={<ChevronRightIcon className={styles.separator} />}
      mt="xs"
      className={styles.breadcrumbWrapper}
    >
      {renderItems()}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
